import React from 'react'

import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { submitFooterForm } from '../../_actions'
import {
    Container,
    Row,
    devices,
    colors,
    Button,
    Input,
    Textarea,
    Form,
    SmallArrow,
} from '../Common'


export const Footer = () => {
    const { register, handleSubmit, errors } = useForm()
    // const { footerMessage, footerError } = useSelector(state => state.form, shallowEqual)
    const dispatch = useDispatch()
    const onSubmit = data => dispatch(submitFooterForm(data))

    const formOptions = { required: 'This field is required' }

    return (
        <FooterWrap>
            <FooterContainer>
                <FooterRow>
                    <FooterHeading>Contact Us</FooterHeading>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Input color={colors.inputRed} aria-label="name" name="name" type="text" placeholder="Name" ref={register(formOptions)} />
                        <Input color={colors.inputRed} aria-label="email" name="email" type="email" placeholder="Email" ref={register(formOptions)} />
                        <Input color={colors.inputRed} aria-label="subject" name="subject" type="text" placeholder="Subject" ref={register(formOptions)} />
                        <Textarea aria-label="message" name="message" placeholder="Message" ref={register(formOptions)} />
                        <Button margintop={20} type='submit' onClick={handleSubmit(onSubmit)}>SUBMIT</Button>
                    </Form>
                </FooterRow>
                <FooterRow>
                    <FooterHeading>Info</FooterHeading>
                    <Address>
                        626 West Cavalcade<br />
                        Houston, TX 77009<br />
                        Phone: <a href="tel:7138613331">713.861.3331</a><br />
                        <br />
                        Visit Our Warehouse<br />
                        — By appointment only
                    </Address>
                    <Icons>
                        <Facebook aria-label='Facebook' href='https://www.facebook.com/artattackco/' target='_blank' rel='noopener noreferrer' />
                        <Linkedin aria-label='Linkedin' href='https://www.linkedin.com/' target='_blank' rel='noopener noreferrer' />
                    </Icons>
                </FooterRow>
                <FooterRow>
                    <EventFormLink as={Link} to={'/event-form/'}>Event form <SmallArrow /> </EventFormLink>
                </FooterRow>
            </FooterContainer>
        </FooterWrap>
    )
}

const FooterWrap = styled.footer`
    padding-top: 50px;
    padding-bottom: 50px;
    width: 100%;
    background: ${colors.red};
    color: ${colors.white};
`

const Address = styled.div`
    a {
        text-decoration: none;
        color: ${colors.white};
    }
`

const FooterContainer = styled(Container)`
    display: flex;
    justify-content: space-between;
    width: auto;

    @media ${devices.small} {
        flex-direction: column;
    }
`

const FooterHeading = styled.div`
    text-transform: uppercase;
    margin-bottom: 5px;
    font-family: pragmatica-extended, sans-serif;
    font-weight: 900;
    font-style: normal;
`

const EventFormLink = styled(FooterHeading)`
    position: relative;
    text-decoration: none;
    color: ${colors.white};
    display: flex;
    align-items: center;
`

const FooterRow = styled(Row)`
    flex-direction: column;
    justify-content: flex-start;
    /* padding: 0 20px; */
    @media ${devices.small} {
        margin-bottom: 30px;
    }
`

const Icons = styled.div`
    margin-top: 20px;
`

const SocialIcon = styled.a`
    background-image: url('/static/images/sprite.svg');
    background-repeat: no-repeat;
    background-position-y: -125px;
    margin-right: 10px;
    display: inline-block;
`

const Facebook = styled(SocialIcon)`
    background-position-x: -100px;
    width: 23px;
	height: 22px;
`

const Linkedin = styled(SocialIcon)`
    background-position-x: -127px;
    width: 22px;
	height: 22px;
`


